export const siteTitle = 'Site Title';
export const siteDescription = 'Site Title';
